import { LedgerCodeModel } from 'src/app/admin/admin-home/admin-fee-definition/ledger-codes/ledger-code.model';
import { FeeDefinitionModel } from 'src/app/admin/admin-home/admin-fee-definition/fee-definition-model';
import { IAmEvidenceDetails, WaivedPaymentModel } from './personScenarioEvidenceDetails';
import { InvoiceModel } from 'src/shared-app-portal/components/profile-payments/invoice-model';
import { CredentialApplicationDefinitionType } from './CredentialApplicationDefinitionType';

export enum RequirementType {
  Regular = 'Regular',
  Payment = 'Payment'
}
export enum FeeAdjustmentConditionOperator {
  After = 'After',
  Before = 'Before'
}
export enum FeeAdjustmentActionType {
  Add = 'Add',
  Subtract = 'Subtract'
}
/** maps to CredentialFeeDefinitionWithIdModel */
export interface ICredentialFeeDefinitionWithIdModel
  extends ICredentialFeeDefinitionModel, IAmEvidenceDetails {
  id: string;
  credentialDefinitionId: string;
  scenarioWithCredentialFeeDefinitions: {
    credentialScenarioDefinitionId: string;
    scenarioName: string;
  }[];
}

export const getEvidenceDetails = (
  details: IAmEvidenceDetails
): {
  invoice: InvoiceModel;
  credentialFeeDefinition: ICredentialFeeDefinitionWithIdModel;
  waivedPayment: WaivedPaymentModel;
} => {
  if (details.evidenceDetailsType === 'CredentialFeeDefinition') {
    return {
      invoice: null,
      credentialFeeDefinition: details as ICredentialFeeDefinitionWithIdModel,
      waivedPayment: null
    };
  }
  if (details.evidenceDetailsType === 'Invoice') {
    return {
      invoice: details as InvoiceModel,
      credentialFeeDefinition: null,
      waivedPayment: null
    };
  }
  if (details.evidenceDetailsType === 'Waived') {
    return {
      invoice: null,
      credentialFeeDefinition: null,
      waivedPayment: details as WaivedPaymentModel
    };
  }
  throw new Error(`unexpected evidenceDetailsType ${details.evidenceDetailsType}`);
};

/** maps to CredentialFeeDefinitionModel */
export interface ICredentialFeeDefinitionModel {
  baseAmount: FeeDefinitionModel;
  type: CredentialApplicationDefinitionType;
  feeAdjustments: IPaymentRequirementFeeAdjustment[];
  formPaymentFees: IFormPaymentFee[];
}

export interface IScenarioRequirementBase {
  name: string;
  showOnPortal: boolean;
  description: string;
  type: RequirementType;
}

export interface IPaymentRequirementFeeAdjustment {
  id: string;
  description: string;
  fee: number;
  actionType: FeeAdjustmentActionType;
  starts: IFeeAdjustmentCondition;
  ends: IFeeAdjustmentCondition;
  ledgerCode: LedgerCodeModel;
  ledgerCodeId: string;
}

export interface IFormPaymentFee {
  formId: string;
  title: string;
  deadline: Date;
  hasExpired: boolean;
}

export interface IFeeAdjustmentCondition {
  days: number;
  operator: FeeAdjustmentConditionOperator;
}

export class ScenarioRequirementDefinition implements IScenarioRequirementBase {
  type: RequirementType;
  evidenceCount: number;

  constructor(
    public id: string,
    public name: string,
    public showOnPortal: boolean,
    public description: string,
    type: RequirementType,
    evidenceCount: number = 0
  ) {
    this.type = RequirementType[type];
    this.evidenceCount = evidenceCount;
  }

  static parse = (obj: any): ScenarioRequirementDefinition =>
    new ScenarioRequirementDefinition(
      obj.id,
      obj.name,
      obj.showOnPortal,
      obj.description,
      obj.type,
      obj.evidenceCount ?? 0
    );
}
